import React from 'react'
import PropTypes from 'prop-types'
import ToggleSimple from '../elements/ToggleSimple'
import LoadingOverlay from '../components/LoadingOverlay'
import globals from '../globals'

const QuietTimeSchedule = (props) => {
    return (
        <LoadingOverlay isLoading={props.isLoading}>
            <div className='quiet-time-schedule-container bg-lightergrey py-4 px-2 p-lg-4 h-100'>
                <div className='d-flex justify-content-center align-items-center'>
                    <div className='bold mr-2'>Focus-time scheduling</div>
                    <ToggleSimple
                        value={props.isEnabled}
                        handleChange={() => props.handleUpdate(!props.isEnabled)}
                    />
                </div>
                <div className={`text-center ${props.isEnabled ? 'mb-4' : ''}`}>
                    <p className='font-small mb-0' dangerouslySetInnerHTML={{ __html: globals.noWidows('Get the kids focused on their homework. Switching on Focus-time scheduling here will block access to the the content categories you have checked below, during the time periods you have scheduled.') }} />
                </div>
                {props.children}
            </div>
        </LoadingOverlay>
    )
}

QuietTimeSchedule.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    isEnabled: PropTypes.bool.isRequired,
    handleUpdate: PropTypes.func.isRequired
}

export default QuietTimeSchedule



// WEBPACK FOOTER //
// ./resources/js/components/QuietTimeSchedule.js